import React from "react";
import { Image } from "react-bootstrap";
import WhiteLogo from "../../../assets/website/img/mylogo-white.png";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <footer id="footer" className="footer dark-background">
        <div className="container">
          <Box
            component="img"
            src={WhiteLogo}
            sx={{ width: "100px" }}
            alt="White Logo"
          />

          <div className="social-links d-flex justify-content-center mt-4">
            <Link to="https://www.facebook.com/mohammad.sn.31" target="_blank">
              <i className="bi bi-facebook" />
            </Link>
            <Link to="https://wa.me/+905389587088" target="_blank">
              <i className="bi bi-whatsapp" />
            </Link>
            <Link to="https://x.com/mohammadsn3" target="_blank">
              <i className="bi bi-twitter-x" />
            </Link>
            <Link to="https://www.instagram.com/mohammad.sn98/" target="_blank">
              <i className="bi bi-instagram" />
            </Link>
            <Link to="https://www.youtube.com/@mohammadsn932" target="_blank">
              <i className="bi bi-youtube" />
            </Link>
            <Link
              to="https://www.linkedin.com/in/mohamad-snobar-3710b219a/"
              target="_blank"
            >
              <i className="bi bi-linkedin" />
            </Link>
            <Link to="https://www.behance.net/mohammadsnGD" target="_blank">
              <i className="bi bi-behance" />
            </Link>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
